import React from "react";
import { axiosget, axiospost } from "../../helpers/httprequest";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import UploadDoc from "./UploadDoc";
import swal from "../../helpers/swal";
import is_null from "../../helpers/is_null";

const ApplicationForm = ({ v }) => {
  const [entry, setentry] = React.useState(null);
  const { data, isLoading, error } = useQuery({
    queryKey: ["admissionRequirementforCourse"],
    queryFn: async () => {
      const req = await axiosget(`ms_programme_admission_requirement/${v?.programme?._id}`);
      return req?.data;
    },
  });
  const _apply = async () => {
    try {
      if (is_null(entry)) {
        swal("danger", "Sorry, mode of entry cannot be null");
        return;
      }
      const req = await axiospost(`ms_applications`, {
        programme: v?.programme?._id,
        payment: v?._id,
        type: entry,
      });
      const { type, message } = req?.data;
      swal(type, message);
    } catch ({ message }) {
      swal(error, message);
    }
  };
  return (
    <>
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      <div className="col-md-12">
        <div className="form-group form-floating">
          <select name="examination" onChange={(e) => setentry(e.target.value)} className={`form-control form-control-lg `}>
            <option value="">Select Option</option>
            <option value="JAMB UTME">JAMB UTME</option>
            <option value="Transfer">Transfer</option>
            <option value="Direct Entry">Direct Entry (DE)</option>
          </select>
          <label htmlFor="firstname">Select Mode of Entry</label>
        </div>
      </div>

      {data && (
        <div className="col-md-12 p-4">
          <p>Please upload all the documents except those targed as optional</p>
          <div className="row">
            {data?.list?.map((r, i) => (
              <UploadDoc r={r} key={`expected_upload_${i}`} />
            ))}
          </div>
          <div className="row">
            {data?.continue === 0 && (
              <div className="col-md-12">
                <button className="btn btn-primary btn-lg btn-block" onClick={_apply}>
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ApplicationForm;
